import { ClipboardCheckIcon } from './ClipboardCheckIcon';

/**
 * author: Google
 * id 2FA574EF-C285-465F-A254-868506FA4273
 * name clipboard-check
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clipboard-check.svg
 * tags
 */
export const AssignmentTurnedInIcon = ClipboardCheckIcon;
export default AssignmentTurnedInIcon